import styled from 'styled-components';

const LinkWrapper = styled.a`
    text-decoration: none !important;
    color: inherit !important;
`;

export default LinkWrapper;
